<template>
  <figure
    v-editable="props.blok"
    :data-uid="props.blok?._uid"
    class="tp-widget text-center"
    :class="[props.blok?.widget]"
  >
    <div
      class="trustpilot-widget"
      data-locale="de-DE"
      data-businessunit-id="50664da000006400051c4308"
      data-style-height="140px"
      data-style-width="100%"
      data-stars="4,5"
      data-review-languages="de"
      v-bind="WIDGETS[props.blok?.widget] ?? []"
    >
      <NuxtLink
        to="https://de.trustpilot.com/review/pflege.de"
        target="_blank"
        rel="noopener"
        title="Zum Testergebnis auf Trustpilot"
        external
      >
        <LazyNuxtImg
          src="https://assets.pflege.de/f/167189/861x461/0bc26f5044/trustpilot-siegel-2026.webp"
          alt="Trustpilot - Gesamtbewertung für pflege.de: Hervorragend"
          placeholder
        />
      </NuxtLink>
    </div>
    <figcaption v-if="props.blok?.widget === 'micro-combo'">
      Viele zufriedene Kundinnen und Kunden empfehlen unsere Services auf Trustpilot.
    </figcaption>
  </figure>
</template>

<script setup>
const props = defineProps({
  blok: {
    type: Object,
    required: false,
    default: new Object(),
  },
})

const isMobileDevice = /Mobi/i.test(window?.navigator?.userAgent ?? '')
const WIDGETS = {
  'carousel': {
    'data-template-id': '53aa8912dec7e10d38f59f36',
    'data-style-height': isMobileDevice ? '290px' : '140px',
    'data-token': '705d30c5-66e9-4105-a117-22e58bc516c6',
  },
  'mini-carousel': {
    'data-template-id': '539ad0ffdec7e10e686debd7',
    'data-style-height': '320px',
    'data-token': 'ae9e2ada-aaa6-4e03-8096-7dac071cb6fc',
  },
  'micro-combo': {
    'data-template-id': '5419b6ffb0d04a076446a9af',
    'data-style-height': '45px',
    'data-token': '7fcaf78d-c179-46f1-ab29-6867b779d9f7',
  },
  'mini': {
    'data-template-id': '53aa8807dec7e10d38f59f32',
    'data-style-height': '85px',
    'data-style-width': '130px',
  },
}

const isWizcoAvailable = inject('isWizcoAvailable', false)
onMounted(() => {
  if(!isWizcoAvailable){
    useHead({
      script: [
        {
          hid: 'trustpilot',
          src: '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js',
          defer: true,
          async: true,
        },
      ],
    })
  }
})
</script>

<style scoped>
figure {
  font-size: 16px;
  display: grid;
  align-items: center;
  gap: .5rem;
  margin: 0;
  height: 100%;

  & img {
    max-width: min(100%, 15rem);
  }
}
</style>